import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Container from "../../UI/Container";
import MuralFotoContainer from "./MuralFotoContainer";

const MuralFotoUsuarioContainer = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const mural = state?.mural;

  // Ao abrir a URL direto (ou recarregar), não há mural no estado da navegação.
  if (!mural) {
    return (
      <Container>
        <Stack alignItems="center" spacing={2} py={6}>
          <Typography color="text.secondary">Nenhum mural selecionado.</Typography>
          <Button variant="contained" component={Link} to="/home">
            Ir para o Início
          </Button>
        </Stack>
      </Container>
    );
  }

  return (
    <Container>
      <Stack direction="row" alignItems="center" spacing={1} mb={3}>
        <Tooltip title="Voltar">
          <IconButton edge="start" onClick={() => navigate(-1)}>
            <ArrowBackIcon />
          </IconButton>
        </Tooltip>
        <Box minWidth={0}>
          <Typography variant="h6" sx={{ overflowWrap: "anywhere" }}>
            {mural.descricao || "Mural de Fotos"}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Mural de Fotos
          </Typography>
        </Box>
      </Stack>
      <MuralFotoContainer mural={mural} />
    </Container>
  );
};

export default MuralFotoUsuarioContainer;
